<template>
    <div class="fst-LlmsSelect">
        <el-select v-model="val" value-key="id" @change="handleChange">
            <el-option v-for="item in list" :key="item.id" :label="item.name" :value="item" />
        </el-select>
    </div>
</template>

<script>
    import _ from 'lodash';
    import { mapState } from 'vuex';

    export default {
        name: "LlmsSelect",
        props: {
            value: Object
        },
        data() {
            return {
                val: this.value
            }
        },
        computed: {
            ...mapState('llm', ['list'])
        },
        methods: {
            handleChange(value) {
                this.$emit('input', value);
            }
        }
    }
</script>

<style lang="scss">
    .fst-LlmsSelect {
        .el-select {
            width: 100%;
        }
    }
</style>
